import columnDrilldownProperties from "../data/columnDrilldown";
import pieDrilldownProperties from "../data/pieDrilldown";

export default {
  loginStatus: false,
  dashboardScreen: "highcharts",
  pieDrilldownProperties,
  columnDrilldownProperties,
  windowWidth: 1366,
  username: "tamzirtapoz",
  password: "tamzirtapoz",
};
